export default __webpack_public_path__ + "static/media/15.650424b0.png";